import graphql from 'babel-plugin-relay/macro';
import React from 'react';
import {useLazyLoadQuery} from 'react-relay/hooks';
import {usePerPage} from 'src/hooks/usePerPage';
import {withSuspense} from 'src/utils/withSuspense';

import {listPagehydrantsQuery} from './__generated__/listPagehydrantsQuery.graphql';
import HydrantsTable from './HydrantsTable';

function ListPage() {
  const {perPage} = usePerPage();
  const data = useLazyLoadQuery<listPagehydrantsQuery>(
    hydrants,
    {first: perPage * 2},
    {fetchPolicy: 'store-and-network'},
  );

  return <HydrantsTable hydrants={data} />;
}

export default withSuspense(ListPage);

const hydrants = graphql`
  query listPagehydrantsQuery($first: Int!) {
    ...HydrantsTable_hydrants @arguments(first: $first)
  }
`;
